import { graphql } from '@/gql';
import type { OperatorActivitiesSummaryQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { OperatorActivitySummary } from '@/models/operator';

export const fetchOperatorActivitiesSummary = async ({
  operatorId,
  slackId,
  startDate,
  endDate,
}: OperatorActivitiesSummaryQueryVariables): Promise<OperatorActivitySummary[]> => {
  const response = await queryExecute({
    query: graphql(`
      query OperatorActivitiesSummary($operatorId: String, $slackId: String, $startDate: String!, $endDate: String!) {
        operatorActivitiesSummary(operatorId: $operatorId, slackId: $slackId, startDate: $startDate, endDate: $endDate) {
          date
          operatorId
          operatorName
          operatorSlackId
          total
          online
          offline
          callback
          callbackActual
          callissue
          coaching
          moretimefor
          technical
          break
          lunch
          restroom
          logoutlogin
          browserclosed
          onlineDateTime
          offlineDateTime
          notes {
            field
            value
          }
        }
      }
    `),
    variables: {
      operatorId,
      slackId,
      startDate,
      endDate,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.operatorActivitiesSummary;
};
